// Sprint 18. Three pages built an address by writing the API address and a
// path side by side. That only works when the API address ends in a slash.
// Production's does. The test setup's does not, so there the browser asked
// for "http://api.localhost:8000scripts/52/csv-data" and the table never
// came. This joins the two with exactly one slash either way.
export const apiUrl = (path: string, base: string = process.env.REACT_APP_API_URL || ''): string => {
  const tail = path.replace(/^\/+/, '');
  if (!base) return tail;
  return `${base.replace(/\/+$/, '')}/${tail}`;
};

export default apiUrl;
